export default __webpack_public_path__ + "static/media/logo_ezeepasar.a441a769.svg";